import { helper as buildHelper } from '@ember/component/helper';

/**
 * Convert cents to the nearest whole dollar value
 */
export function centsToDollars(intValue) {
  const roundedDecimal = Math.round(intValue / 100);
  return roundedDecimal.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export default buildHelper((args) => centsToDollars(...args));
